<div>
  <div class="flex-grow-1 panel-border animated fadeInLeft">
    <div class="p-2" data-toggle="collapse" data-target="#builder">
      <i
        class="fas pe-1 text-muted"
        [ngClass]="{ 'fa-minus': expanded, 'fa-plus': !expanded }"
        (click)="onToggleExpanded()"
      ></i>
      <ng-content select="span.title"></ng-content>
    </div>

    <ng-content select="span.body" *ngIf="expanded"></ng-content>
  </div>
</div>
